import { render, staticRenderFns } from "./CanvasInput.vue?vue&type=template&id=bcfb19e8&scoped=true"
import script from "./CanvasInput.vue?vue&type=script&lang=js"
export * from "./CanvasInput.vue?vue&type=script&lang=js"
import style0 from "./CanvasInput.vue?vue&type=style&index=0&id=bcfb19e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfb19e8",
  null
  
)

export default component.exports